var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 42,
    viewBox: "0 0 55 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 38V28C3 26.8954 3.89543 26 5 26H15C16.1046 26 17 26.8954 17 28V38C17 39.1046 16.1046 40 15 40H5C3.89543 40 3 39.1046 3 38Z",
    fill: "#E3F2FD",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38V4C37 2.89543 37.8954 2 39 2H49C50.1046 2 51 2.89543 51 4V38C51 39.1046 50.1046 40 49 40H39C37.8954 40 37 39.1046 37 38Z",
    fill: "#E3F2FD",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 38V16C20 14.8954 20.8954 14 22 14H32C33.1046 14 34 14.8954 34 16V38C34 39.1046 33.1046 40 32 40H22C20.8954 40 20 39.1046 20 38Z",
    fill: "white",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reportsIcon.4d197dfc563feb1648b40de444fd3761.svg";
export { ForwardRef as ReactComponent };